import * as React from 'react';

import type {SalesAutomationStage as SalesAutomationStageFragment} from 'nutshell-graphql-types';

import {useGetInboxStatus} from '../../../setup/text-messaging/graphql/hooks/use-get-inbox-status';

import {TextAutomationCtaBanner} from '../../ctas/text-automation-cta-banner';

import {calculateBoardWidth} from '../calculate-board-width';
import {StageCardsTextAutomationsContainer} from '../card-containers/stage-cards-text-automations-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    stages: SalesAutomationStageFragment[];
    hideCards: boolean;
};

/*
 * Top-level component responsible for rendering the entire "goals"
 * section (row) on the sales automation setup board.
 */
export function SalesAutomationTextAutomations(props: Props) {
    const {inboxStatus, isLoading} = useGetInboxStatus();
    const boardWidth = calculateBoardWidth(props.stages.length);
    const canConfigureAutomations =
        inboxStatus &&
        inboxStatus.status === 'VALID' &&
        inboxStatus.planStatus.status !== 'NO_PLAN';

    const collapsibleSectionContents = canConfigureAutomations ? (
        props.stages.map((stage) => {
            return (
                <StageCardsTextAutomationsContainer
                    key={stage.id}
                    hideCards={props.hideCards}
                    parentId={stage.id}
                />
            );
        })
    ) : (
        <TextAutomationCtaBanner width={boardWidth} />
    );

    return (
        <CollapsibleSection type='textAutomations'>
            {!isLoading && collapsibleSectionContents}
        </CollapsibleSection>
    );
}
